import React from 'react';
import USDCTestnetFaucet from '../components/USDCTestnetFaucet';
import Sidebar from '../components/Sidebar';
import NavBar from '../components/NavBar';


function InsightPage() {
    return (
        <div>
            <div class="container-scroller">
                <Sidebar />
                <div class="container-fluid page-body-wrapper">
                    <NavBar />
                    <div class="main-panel">
                        <div class="content-wrapper-insurance">
                            <div class="row">
                                <div class="col-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <USDCTestnetFaucet />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    );
}

export default InsightPage;